import React, {useRef} from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';

import PrinterIcon from '@material-ui/icons/Print';

import Overview from "./Overview";
import TaxBreakdown from "./TaxBreakdown";
import AddressChange from "./AddressChange";
import Header from "./Header";

import Card from "../Card";

import { useReactToPrint } from 'react-to-print';

import { Context as PropertyContext } from "../../context/property.context";
import { Context as AuthContext } from '../../context/auth.context';



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));



export class ComponentToPrint extends React.PureComponent {
  render() {
    return (
      <div className="printOverviewandTaxbreakdown" >

        <div style={{height: "92%", padding: "5vh"}}>
          <h2>Overview</h2>
          <Overview />
        </div>
        {this.props.auth.state.merchant.enableCoris == 0 && (
          <div style={{height: "88%", padding: "5vh"}}>
            <h2>Tax Breakdown</h2>
            <TaxBreakdown />
          </div>
        )}
      </div>
    );
  }
}


function SimpleTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { state, readTaxBill } = React.useContext(PropertyContext);
  const auth = React.useContext(AuthContext);

  const { id } = useParams();

  React.useEffect(() => {
    readTaxBill(id);
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint( {
    content: () => componentRef.current,
  });

  return (
    <div className={classes.root}>

      <ComponentToPrint auth={auth} ref={componentRef} />
      <Grid container justify="flex-end">
        <Button
          variant="contained"
          onClick={handlePrint}
          style={{ 
            justifyContent: "flex-end", 
            alignItems: "flex-end", 
            flexDirection: "row",
          }}
        >
          <PrinterIcon style={{marginRight:5}} /> Print
        </Button>
      </Grid>



      <div className="noPrint">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          style={{ padding: 0 }}
        >
          <Tab label="Overview & Pay" {...a11yProps(0)} style={{ padding: 0 }} />
          {auth.state.merchant.enableCoris == 0 && (
            <Tab label="Tax Breakdown" {...a11yProps(1)} />
          )}
          {/* <Tab label="Address Change" {...a11yProps(2)} /> */}
        </Tabs>
        {state.loadingReadBill ? (
          <p>Loading</p>
        ) : (
          <>
            <TabPanel value={value} index={0}>
              <Overview />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <TaxBreakdown />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <AddressChange />
            </TabPanel>
          </>
        )}
      </div>

    </div>
  );
}

const ViewItem = (props) => {
  return (
    <>
      <Header />
      <Card>
        <SimpleTabs />
      </Card>
    </>
  );
};

export default ViewItem;
